module.exports = __webpack_public_path__ + "static/media/Chopper.f0759f5c.svg";